module.exports = __webpack_public_path__ + "static/media/Kessel105-Light.1c500bc3.woff";